import React from 'react';
import Portfolio from './components/Portfolio';

const App: React.FC = () => {
  return <Portfolio />;
};

export default App;
